import {
  contractTypeSeed,
  employmentTypeSeed,
  mansioneSeed,
  repartoSeed,
  ruoloSeed,
} from '../data/workerOptions'
import { WorkerOptionKind } from '../types/worker'

type Listener = () => void

// Self-feeding option lists shared by every worker form
class WorkerOptionsStore {
  private options: Record<WorkerOptionKind, string[]> = {
    employmentType: [...employmentTypeSeed],
    contractType: [...contractTypeSeed],
    mansione: [...mansioneSeed],
    reparto: [...repartoSeed],
    ruolo: [...ruoloSeed],
  }
  private listeners = new Set<Listener>()

  getAll(): Record<WorkerOptionKind, string[]> {
    return this.options
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  // Returns the stored value (existing match if already present)
  add(kind: WorkerOptionKind, value: string): string {
    const trimmed = value.trim()
    const existing = this.options[kind].find(
      (o) => o.toLowerCase() === trimmed.toLowerCase(),
    )
    if (existing) return existing
    this.options = { ...this.options, [kind]: [...this.options[kind], trimmed] }
    this.listeners.forEach((l) => l())
    return trimmed
  }
}

export const workerOptionsStore = new WorkerOptionsStore()
